import { SetStateAction, Dispatch } from 'react';
import BigNumber from 'bignumber.js';
import { OrderSide, OrderType } from '#/api/orders';
import { OrderFormState, INITIAL_STATE } from './form-state';

export interface OrderFormActions {
  readonly updateAsset: (asset: string) => void;
  readonly updateAmount: (amount: string) => void;
  readonly updateLimitPrice: (limitPrice: string) => void;
  readonly updateType: (type: OrderFormState['type']) => void;
  readonly updateSide: (side: OrderFormState['side']) => void;
  readonly updateIsPostOnly: (isPostOnly: boolean) => void;
  readonly updateTimeInForce: (
    timeInForce: OrderFormState['timeInForce'],
  ) => void;
  readonly reset: () => void;
}

export function createActions(
  setState: Dispatch<SetStateAction<OrderFormState>>,
): OrderFormActions {
  return {
    updateAsset(asset: string) {
      setState((state) => ({ ...state, asset }));
    },
    updateAmount(amount: string) {
      const parsed = new BigNumber(amount);
      const sanitized = parsed.isFinite() ? parsed : null;
      setState((state) => ({ ...state, amount: sanitized }));
    },
    updateLimitPrice(limitPrice: string) {
      const parsed = new BigNumber(limitPrice);
      const sanitized = parsed.isFinite() ? parsed : null;
      setState((state) =>
        state.type === 'MARKET'
          ? state
          : {
              ...state,
              limitPrice: sanitized,
            },
      );
    },
    updateType(type: OrderType) {
      setState((state) => ({ ...state, type }));
    },
    updateSide(side: OrderSide) {
      setState((state) => ({ ...state, side }));
    },
    updateIsPostOnly(isPostOnly: OrderFormState['isPostOnly']) {
      setState((state) => ({ ...state, isPostOnly }));
    },
    updateTimeInForce(timeInForce: OrderFormState['timeInForce']) {
      setState((state) => ({ ...state, timeInForce }));
    },
    reset() {
      setState(
        ({
          type,
          side,
          asset,
          isPostOnly,
          timeInForce,
          limitPrice,
          amount,
        }) => ({
          ...INITIAL_STATE,
          limitPrice,
          amount,
          isPostOnly,
          timeInForce,
          type,
          side,
          asset,
        }),
      );
    },
  };
}
